import React from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';

import { BasicLayout } from '../basic.layout';
import LoginProcessing from '../../pages/login.process';
import Error404 from '../../pages/error404';
import ChatRoutes from '../../../modules/chat/chat.routes';
import Login from '../../commons/login/login.comp';
import LoginSelection from '../../pages/loginSelection';

const BasicRoutes: React.FC = () => {
    const location = useLocation();
    return (
        <div>
            <Routes>
                <Route path="/" element={<BasicLayout />}>
                    <Route index element={<Navigate to={`/chat${location.search}`} />} />
                    <Route path="/chat" element={<Login><ChatRoutes /></Login>} />
                    <Route path="/loginSelection" element={<LoginSelection />} />
                    <Route path="/loginProcess" element={<LoginProcessing />} />
                    <Route path="*" element={<Error404 />} />
                </Route>
            </Routes>
        </div>
    );
};



export default BasicRoutes;
